import { useContext } from "react";
import { useQuery } from "react-query";
import { apiAxios } from "services/HttpServices";
import { LoginStateContext } from "context/Login/LoginState";

async function fetchPaperMaterial() {
  try {
    const res = await apiAxios.get("/jobs/paper_materials");
    return res.data.data;
  } catch (e) {
    console.log(e);
  }
}

function usePaperMaterialData() {
  const { user: userState } = useContext(LoginStateContext);
  return useQuery(["paper-materials"], fetchPaperMaterial, {
    enabled: userState.isLoggedIn,
  });
}

export default usePaperMaterialData;
